import { submitLogoutForm } from '@rover/rsdk/src/modules/Network/submitLogoutForm';
import { clearOnLogout as localStorageClearOnLogout } from '@rover/utilities/localStorage';
import { clear as clearSessionStorage } from '@rover/utilities/sessionStorage';

export type LogoutConfig = {
  nextLocation: string;
  ref?: string;
  beforeNavCallback?: () => void;
};
export default async function logout({
  nextLocation,
  ref,
  beforeNavCallback,
}: LogoutConfig): Promise<void> {
  localStorageClearOnLogout();
  clearSessionStorage();
  beforeNavCallback && beforeNavCallback();
  submitLogoutForm(nextLocation, ref);
}
